import TomSelect from "tom-select";
import Helpers from "../utils/helpers";

const Checkout = {
  handlePvnRate: null,

  init() {
    if ($("body").hasClass("woocommerce-order-received")) {
      return;
    }

    this.load();
    this.events();
  },

  load() {
    // Billing person.
    const person = $("input[name=billing_person]").val();
    Checkout.handlePerson(person);

    // Shipping method.
    const methodEl = $('input[name="shipping_method[0]"]:checked');

    if(methodEl.data('show-fee') == 'no') {
      $('.pickup_fee_message, .cs-payment__btn-continue, .progress, .payments_fee_message, .fee_summary').hide();
      $('.fee_summary_free').show();
      $("#checkout-totals").data('show-fee', 0);
    } else {
      $('.fee_summary_free').hide();
      $('.pickup_fee_message, .pickup_fee_price, .progress, .payments_fee_message, .fee_summary').show();
      if($("#checkout-totals").data('fee') > 0) {
        $('.cs-payment__btn-continue').show();
      }
      $("#checkout-totals").data('show-fee', 1);
    }

    Checkout.handleShippingOptions(methodEl);
    Checkout.handlePaymentOptions(methodEl);

    // Payment method.
    const paymentMethod = $("input[name=payment_method]:checked").val();
    Checkout.showPaymentForm(paymentMethod);

    // Calc tax.
    Checkout.calculateTax();

    // Calculate total.
    setTimeout(() => {
      Checkout.calcTotal();
    }, 50);
  },

  events() {
    $("body").on("cab_checkout_error", () => {
      const termsEl = $("#terms");
      if (!termsEl.prop("checked")) {
        termsEl.addClass("error");
      } else {
        termsEl.removeClass("error");
      }
    });

    $("button[data-step]").on("click", function () {
      const nextStep = $(this).data("step");

      Checkout.nextStep(nextStep);
    });

    $("button[data-person]").on("click", function () {
      const person = $(this).data("person");

      $("button[data-person]").removeClass("tab-nav-item--active");
      $(this).addClass("tab-nav-item--active");

      $("[name=billing_person]").val(person).trigger("change");

      Checkout.handlePerson(person);
    });

    // On VAT change
    const isVat = $('input[name="billing_is_vat"]').is(":checked");
    Checkout.showVatField(isVat);

    $('input[name="billing_is_vat"]').on("change", function () {
      const isVat = $(this).is(":checked");

      Checkout.showVatField(isVat);
    });

    // On shipping method change
    $('input[name="shipping_method[0]"]').on("change", function () {
      const methodEl = $(this);
      $('input[name="shipping_method[0]"]').removeAttr("checked");
      $(".local_pickup_description_box").addClass("hidden");

      methodEl.attr("checked", "checked");

      if(methodEl.data('show-fee') == 'no') {
        $('.pickup_fee_message, .cs-payment__btn-continue, .progress, .payments_fee_message, .fee_summary').hide();
        $('.fee_summary_free').show();
        $("#checkout-totals").data('show-fee', 0);
      } else {
        if($("[name=local_pickup]:checked").hasClass('no_fee')) {
          $('.pickup_fee_price, .payments_fee_message').show();
          if($("#checkout-totals").data('fee') == 0) {
            $('.fee_summary_free').show();
          }
        } else {
          $('.fee_summary_free').hide();
          $('.pickup_fee_message, .pickup_fee_price, .payments_fee_message, .fee_summary').show();
        }

        if(parseFloat($("#checkout-totals").data("fee-max")) > 0) {
          $('.progress').show();
        }
        if($("#checkout-totals").data('fee') > 0) {
          $('.cs-payment__btn-continue').show();
        }
        $("#checkout-totals").data('show-fee', 1);
      }

      Checkout.handleShippingOptions(methodEl);
      Checkout.handlePaymentOptions(methodEl);
    });

    // On payment method change
    $("input[name=payment_method]").on("change", function () {
      const paymentMethod = $(this).val();
      Checkout.showPaymentForm(paymentMethod);
    });

    const pickup = $("[name=local_pickup]:checked").val();
    $(".box-pickup").addClass("hidden");
    $(`.box-pickup[data-pickup="${pickup}"]`).removeClass("hidden");

    $(".local_pickup_description_box").addClass("hidden");
    $(`.local_pickup_description_box[data-id="${pickup}"]`).removeClass("hidden");

    $("[name=local_pickup]").on("change", function () {
      const pickup = $(this).val();

      $(".box-pickup").addClass("hidden");
      $(`.box-pickup[data-pickup="${pickup}"]`).removeClass("hidden");

      $(".local_pickup_description_box").addClass("hidden");
      $(`.local_pickup_description_box[data-id="${pickup}"]`).removeClass("hidden");

      if($(this).hasClass('no_fee')) {
        $('.pickup_fee_message, .cs-payment__btn-continue, .progress, .payments_fee_message, .fee_summary').hide();
        $("#checkout-totals").data('show-fee', 0);
        $('.fee_summary_free').show();
      } else {
        $('.pickup_fee_message, .pickup_fee_price, .payments_fee_message, .fee_summary').show();
        $('.fee_summary_free').hide();
        if(parseFloat($("#checkout-totals").data("fee-max")) > 0) {
          $('.progress').show();
        }
        if($("#checkout-totals").data('fee') > 0) {
          $('.cs-payment__btn-continue').show();
        }
        $("#checkout-totals").data('show-fee', 1);
      }

      Checkout.calcTotal();
    });

    // Handle VAT
    $(`[name="billing_person"], [name="billing_is_vat"]`).on(
      "change",
      function () {
        Checkout.calculateTax();
      }
    );
  },

  calculateTax() {
    if (Checkout.handlePvnRate) {
      Checkout.handlePvnRate.abort();
    }

    const person = $("[name=billing_person]").val();
    const isVat = $("[name=billing_is_vat]").is(":checked");

    Checkout.handlePvnRate = $.ajax({
      url: ajaxurl,
      type: "POST",
      data: {
        action: "handle_pvn_rate",
        person: person,
        is_vat: isVat,
      },
      success: function (response) {
        $("#checkout-products").html(response.products);
        $("#checkout-summary").html(response.summary);

        const methodEl = $('input[name="shipping_method[0]"]:checked');

        if(methodEl.data('show-fee') == 'no') {
          $('.pickup_fee_message, .cs-payment__btn-continue, .progress, .payments_fee_message, .fee_summary').hide();
          $('.fee_summary_free').show();
          $("#checkout-totals").data('show-fee', 0);
        } else {
          if($("[name=local_pickup]:checked").hasClass('no_fee')) {
            $('.pickup_fee_price, .payments_fee_message').show();

            if($("#checkout-totals").data('fee') == 0) {
              $('.fee_summary_free').show();
            }

          } else {
            $('.fee_summary_free').hide();
            $('.pickup_fee_message, .pickup_fee_price, .payments_fee_message, .fee_summary').show();
          }
          if($("#checkout-totals").data('fee') > 0) {
            $('.cs-payment__btn-continue').show();
          }
          $("#checkout-totals").data('show-fee', 1);
        }

        setTimeout(() => {
          Checkout.calcTotal();
        }, 50);
      },
    });
  },

  showVatField(isVat) {
    const vatEl = $("[data-vat]");
    if (isVat) {
      vatEl.removeClass("hidden");
      vatEl.find("input").removeClass("disabled");
    } else {
      vatEl.addClass("hidden");
      vatEl.find("input").addClass("disabled");
    }
  },

  showPaymentForm(paymentMethod) {
    $("[data-payment]").each(function () {
      let paymentMethods = $(this).data("payment").split(",");
      if (paymentMethods.includes(paymentMethod)) {
        $(this).removeClass("hidden");
      } else {
        $(this).addClass("hidden");
      }
    });
  },

  handleShippingOptions(methodEl) {
    const courierFields = $(".shipping-courier");
    const pickupFields = $(".shipping-pickup");
    const deliveryFields = $(".shipping-delivery");

    // Hide all fields
    $(".shipping-method-fields").addClass("hidden");

    courierFields.addClass("hidden");
    courierFields.find("input").addClass("disabled");

    pickupFields.addClass("hidden");
    pickupFields.find("input").addClass("disabled");

    deliveryFields.addClass("hidden");
    deliveryFields.find("input").addClass("disabled");

    if ("courier" == methodEl.data("type")) {
      courierFields.removeClass("hidden");
      courierFields.find("input").removeClass("disabled");
    } else if ("pickup" == methodEl.data("type")) {
      pickupFields.removeClass("hidden");
      pickupFields.find("input").removeClass("disabled");

      if($('.shipping-pickup input[name="local_pickup"]:checked').hasClass('no_fee')) {
        $('.pickup_fee_message .cs-payment__btn-continue, .progress, .payments_fee_message, .fee_summary').hide();
        $('.fee_summary_free').show();
        $("#checkout-totals").data('show-fee', 0);
      } else {
        if($("[name=local_pickup]:checked").hasClass('no_fee')) {
          $('.pickup_fee_price, .payments_fee_message').show();
          $('.fee_summary_free').show();
        } else {
          $('.fee_summary_free').hide();
          $('.pickup_fee_message, .pickup_fee_price, .payments_fee_message, .fee_summary').show();
        }
        if($("#checkout-totals").data('fee') > 0) {
          $('.cs-payment__btn-continue').show();
        }
        $("#checkout-totals").data('show-fee', 1);
      }

      Checkout.calcTotal();

    } else if ("delivery" == methodEl.data("type")) {
      deliveryFields.removeClass("hidden");
      deliveryFields.find("input").removeClass("disabled");
    }

    // Disable parcel select
    $("[data-method]").find("select").removeAttr("name");
    $("[data-method]").find("select").addClass("disabled");
    $("[data-method]").find("select").attr("disabled", "disabled");

    // Show fields based on selected method
    const targetFieldsEl = $(`[data-method="${methodEl.val()}"]`);

    targetFieldsEl.removeClass("hidden");

    const selectEl = targetFieldsEl.find("select");

    if (selectEl.length) {
      selectEl.removeAttr("disabled");
      selectEl.removeClass("disabled");

      if (!selectEl.hasClass("tomselected")) {
        new TomSelect(selectEl[0], {
          maxOptions: null,
        });
      }
    }

    if (selectEl) {
      selectEl.attr("name", selectEl.data("name"));
    }
  },

  handlePerson(person) {
    $(".billing[data-person]").addClass("hidden");
    $(".billing[data-person=legal]").find("input").addClass("disabled");

    $(`.billing[data-person="${person}"]`).removeClass("hidden");
    $(`.billing[data-person="${person}"]`)
      .find("input")
      .removeClass("disabled");
  },

  nextStep(nextStep) {
    $(".woocommerce-NoticeGroup").remove();

    if (!Helpers.validate($(`.step[data-step="${nextStep - 1}"]`))) {
      $("html, body").animate(
        {
          scrollTop:
            $(`.step[data-step="${nextStep - 1}"] .error`).offset().top - 100,
        },
        "fast"
      );
      return;
    }

    Checkout.handleNav(nextStep);

    const checkoutFormEl = $(".checkout");

    checkoutFormEl.attr("data-step", nextStep);

    if (nextStep > 1) {
      Checkout.calcTotal();
    }

    $("html, body").animate(
      {
        scrollTop: checkoutFormEl.offset().top,
      },
      "fast"
    );

    const pickup = $("[name=local_pickup]:checked").val();
    $(".local_pickup_description_box").addClass("hidden");
    $(`.local_pickup_description_box[data-id="${pickup}"]`).removeClass("hidden");

    $(`.step[data-step]`).addClass("hidden");
    $(`.step[data-step="${nextStep}"]`).removeClass("hidden");
  },

  handleNav(step) {
    $(".checkout-nav__item").removeClass("active filled");
    $(".checkout-nav__item").each(function () {
      const navItemEl = $(this);
      const navStep = parseInt(navItemEl.data("step"));

      if (navStep < step) {
        navItemEl.addClass("filled");
      } else if (navStep == step) {
        navItemEl.addClass("active");
      }
    });
  },

  calcTotal() {
    // Get data.
    const totalsEl = $("#checkout-totals");
    const total = parseFloat(totalsEl.data("total"));
    const vat = parseFloat(totalsEl.data("vat"));
    const fee = parseFloat(totalsEl.data("fee"));
    const show_fee = parseFloat(totalsEl.data("show-fee"));
    const fee_tax = parseFloat(totalsEl.data("fee-tax"));
    const coupon =
      0 < parseFloat(totalsEl.data("coupon"))
        ? parseFloat(totalsEl.data("coupon"))
        : 0;

    const currency = totalsEl.data("currency");

    let grandTotal = 0;

    if(show_fee === 1) {
      grandTotal = total + vat - coupon + fee;
    } else {
      grandTotal = total + vat - coupon - fee_tax;
    }

    totalsEl.removeClass("hidden");

    // Shipping
    const shippingMethod = $('input[name="shipping_method[0]"]:checked');

    let shippingVat = parseFloat(shippingMethod.data("tax"));
    let shippingCost =
      Math.ceil((parseFloat(shippingMethod.data("cost")) - shippingVat) * 100) /
      100;

    grandTotal += shippingCost + shippingVat;

    const shipping = {
      label: shippingMethod.data("label"),
      cost: shippingCost,
    };

    let totalVat = vat + shippingVat;

    $("#price-total-vat").text(`${totalVat.toFixed(2)} ${currency}`);

    if (shippingCost > 0) {
      let shippingHtml = `<p class="checkout-total-item__label">
          Piegāde: ${shipping.label}
        </p>
        <p class="checkout-total-item__value order-shipping">
          ${shippingCost.toFixed(2)} ${currency}
        </p>`;
      $("#total-shipping").html(shippingHtml);
    } else {
      $("#total-shipping").html("");
    }

    $("#price-grand-total").text(grandTotal.toFixed(2));
  },

  handlePaymentOptions(shippingMethodEl) {
    const shippingMethod = shippingMethodEl.val().split(":")[0];
    // local_pickup

    $("[name=payment_method]").each(function () {
      const paymentMethodEl = $(this);

      let shippingMethods = paymentMethodEl.data("shipping").split(",");

      shippingMethods = shippingMethods.filter((item) => item !== "");

      if (shippingMethods.length > 0) {
        if (shippingMethods.includes(shippingMethod)) {
          paymentMethodEl.parent().removeClass("hidden");
        } else {
          paymentMethodEl.parent().addClass("hidden");
        }
      }
    });

    // TODO select other payment method if current is hidden
  },
};

export default Checkout;
